import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import ALLF from "../../assets/AllFactory.png";

const AllFactoryMaintenance = () => {
  return (
    <>
      <SeoHead
        title="Factory Scheduled Maintenance in Temecula | Advanced Automotive Smog"
        description="Manufacturer-recommended factory maintenance in Temecula, covering fluids, filters, and inspections at the right mileage intervals for your vehicle."
        path="/services/all-factory"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="All Factory Maintenance"
          path="/services/all-factory"
          description="Manufacturer-recommended factory maintenance in Temecula, covering fluids, filters, and inspections at the right mileage intervals."
          serviceType="Factory scheduled maintenance"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={ALLF}
                alt="Factory maintenance service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Factory Scheduled Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              All Factory Maintenance
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your vehicle running like it just left the showroom. We follow
              your manufacturer&apos;s maintenance schedule so you don&apos;t
              have to guess what&apos;s due—or when.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is Factory Maintenance?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Factory maintenance is the recommended service routine designed by
              your vehicle&apos;s manufacturer. It includes fluid changes,
              filters, inspections, and part replacements at specific mileage
              intervals to keep your engine, transmission, brakes, and more
              performing at their best.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Scheduled maintenance based on factory intervals</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality fluids, filters, and replacement parts</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Multi-point inspections to catch issues early</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Service for all makes and models</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps protect performance, reliability, and resale value</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default AllFactoryMaintenance;
